import { PDFDocument } from 'pdf-lib'

import { convertDateString, createTable, savePdf } from '../../../../helpers/pdf'
import { IEventInterface } from '../../../../models/events/event.interface'

export interface GroupedRows {
  day: string
  date: Date
  facility: string
  rows: string[][]
}

export const createClassScheduleByDayAndFacility = async (
  event: IEventInterface,
  groupedData: GroupedRows[]
) => {
  // Create a new PDF document
  const pdfDoc = await PDFDocument.create()
  const headers = ['Time • Day ', 'Facility', 'Class']
  const colWidths = [20, 20, 60] // in %
  const titleText = 'Class Schedule'
  const printedText = `^^Printed ${convertDateString(new Date(), 'tdm')}^^`
  const urlText = 'www.thepegasus.app'

  // table for each group
  for (const [index, group] of groupedData.entries()) {
    const formattedDate = convertDateString(group.date, 'dm') // Format like "08 Jul"

    const groupTitle = `**${group.day}, ${formattedDate}** • ${group.facility} • ~~${group.rows.length} classes~~`

    await createTable({
      pdfDoc,
      headers,
      rows: group.rows,
      colWidths,
      textAboveTheFirstTable: groupTitle,
      printedText: index === 0 ? printedText : undefined, // only show printedText on first page
      titleText: index === 0 ? titleText : undefined, // only show title on first page
      urlText: index === 0 ? urlText : undefined, // only show url on the first page
      currentPageNumber: index + 1,
      event,
    })
  }

  await savePdf(
    pdfDoc,
    `Event Reports - Class Schedule by Day and Facility - ${event?.eventName}.pdf`
  )
}
